export default __webpack_public_path__ + "static/media/icon-timer.e56e9c87.svg";